// extracted by mini-css-extract-plugin
export var navigationItem = "styles-module--navigation-item--47cd4";
export var navigationLink = "styles-module--navigation-link--483f9";
export var navigationLinkActive = "styles-module--navigation-link-active--5d3be";
export var navigationWrapper = "styles-module--navigation-wrapper--e3c6a";
export var selectWrapper = "styles-module--select-wrapper--de441";
export var wrapper = "styles-module--wrapper--00fb3";